import CryptoJS from 'crypto-js';
import fernet from 'fernet';
import base64 from 'base-64'
import { envSetting } from '../constants/envSetting';

/**** Export functions  ****/
/**
 * Encrypt text with AES
 * @param {String} text
 * @returns
 */
export const encryptAES = text => {
  const encryptedJson = CryptoJS.AES.encrypt(JSON.stringify(text), envSetting.cryptoAesPassword).toString()
  const encryptedText = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(encryptedJson))
  return encryptedText;
};

/**
 * Decrypt text with AES
 * @param {String} text
 * @returns
 */
export const decryptAES = text => {
  const decryptedData = CryptoJS.enc.Base64.parse(text).toString(CryptoJS.enc.Utf8)
  const bytes = CryptoJS.AES.decrypt(decryptedData, envSetting.cryptoAesPassword).toString(CryptoJS.enc.Utf8)
  const decryptedText = JSON.parse(bytes)
  return decryptedText;
};

/**
 * Decrypt token with Fernet
 * @param {String} token
 * @returns
 */
export const decryptFernet = token => {
  const encryptedKey = envSetting.cryptoAesPassword 
  const decodedToken = base64.decode(token)
  const secret = new fernet.Secret(encryptedKey)
  const tokenObj = new fernet.Token({
    secret,
    token: decodedToken,
    ttl: 0
  })

  let decryptedToken
  try {
    decryptedToken = tokenObj.decode();
  } catch (error) {
    console.error('Error: ', error.message);
  }

  return decryptedToken
}